import { ComponentStyleConfig } from '@chakra-ui/react';

/**
 * Extends base Button theme with 3p Figma design.
 * See RippleButton for the material ui behaviour, this was not possible in css only in this theme.
 *
 * @see https://github.com/chakra-ui/chakra-ui/blob/092b20f3e93064c1db312062b76b420a7ed1703b/packages/theme/src/components/button.ts
 * @see https://www.figma.com/file/AVVZO09XE8fZ0uuOaJYcQg/B2C-Onboarding---for-Dev?node-id=2759%3A24812
 */
export const Button: ComponentStyleConfig = {
    defaultProps: {
        variant: 'primary',
        sizes: 'md'
    },
    baseStyle: {
        fontWeight: '500',
        borderRadius: '80px',
        outline: 'none',
        border: 'none',
        cursor: 'pointer',
        overflow: 'hidden',
        _disabled: {
            opacity: '0.4',
            cursor: 'not-allowed',
            boxShadow: 'none'
        }
    },
    sizes: {
        small: {
            h: '30px',
            px: '16px',
            minW: '30px',
            fontSize: '13px',
            lineHeight: '22px'
        },
        medium: {
            h: '40px',
            px: '24px',
            minW: '40px',
            fontSize: '14px',
            lineHeight: '24px'
        },
        large: {
            h: '52px',
            px: '32px',
            minW: '52px',
            fontSize: '18px',
            lineHeight: '26px'
        }
    },
    variants: {
        primary: {
            bg: 'primary.600',
            color: 'secondary.0',
            _hover: {
                bg: 'primary.700',
                _disabled: { bg: 'primary.600' }
            }
        },
        secondary: {
            backgroundColor: 'secondary.0',
            color: 'primary.600',
            borderColor: 'primary.300',
            borderWidth: '1px',
            borderStyle: 'solid',
            _hover: {
                bg: 'primary.100',
                _disabled: { bg: 'secondary.0' }
            }
        },
        tertiary: {
            backgroundColor: 'secondary.0',
            color: 'primary.600',
            _hover: {
                bg: 'primary.100',
                _disabled: { bg: 'secondary.0' }
            }
        }
    }
};
